export const version = '1.2.0'
export const navbarBreakPoint = 'xl'
export const topNavbarBreakpoint = 'lg'

export const settings = {
  isFluid: false,
  isRTL: false,
  isDark: false,
  isTopNav: false,
  isVertical: true,
  get isCombo () {
    return this.isVertical && this.isTopNav
  },
  showBurgerMenu: false,
  currency: '$',
  isNavbarVerticalCollapsed: false,
  navbarStyle: 'transparent'
}

const config = { version, navbarBreakPoint, topNavbarBreakpoint, settings }
export default config
